import resume1 from "./pics/1.png";
import resume2 from "./pics/2.png";
import resume3 from "./pics/3.png";
import resume4 from "./pics/4.png";
import resume5 from "./pics/5.png";
import resume6 from "./pics/6.png";
import resume7 from "./pics/7.png";
import resume8 from "./pics/8.png";
import resume9 from "./pics/9.png";
import resume10 from "./pics/10.png";
import resume11 from "./pics/11.png";
import resume12 from "./pics/12.png";
import resume13 from "./pics/13.png";
import resume14 from "./pics/14.png";
import resume15 from "./pics/15.png";
import resume16 from "./pics/16.png";
import resume17 from "./pics/17.png";
import resume18 from "./pics/18.png";
import resume19 from "./pics/19.png";
import resume20 from "./pics/20.png";
import resume21 from "./pics/21.png";
import resume22 from "./pics/22.png";
import resume23 from "./pics/23.png";
import landingPortrait from "./assets/landing-baby.jpeg";
import { useEffect, useReducer, useRef } from "react";
import { createBrowserRouter, Link, RouterProvider } from "react-router-dom";
import SmokingPage, { SmokingDebugPage } from "./SmokingPage";
import MapdlePage, { MapdleDebugPage } from "./MapdlePage";
import BaccaratPage from "./BaccaratPage";
import PerfectPitchPage from "./PerfectPitchPage";
import MaptapPage from "./MaptapPage";
import IranWarPage from "./IranWarPage";
import UltimateTexasHoldemPage from "./UltimateTexasHoldemPage";
import UltimateTexasHoldemChartPage from "./UltimateTexasHoldemChartPage";
import HanziRecallPrivacyPage from "./HanziRecallPrivacyPage";
import HanziBlitzPage from "./HanziBlitzPage";

const ROW_COUNT = 6;
const COLUMN_COUNT = 4;
const EMPTY_TILE_ID = "empty";

const TILE_IMAGES = [
  resume1,
  resume2,
  resume3,
  resume4,
  resume5,
  resume6,
  resume7,
  resume8,
  resume9,
  resume10,
  resume11,
  resume12,
  resume13,
  resume14,
  resume15,
  resume16,
  resume17,
  resume18,
  resume19,
  resume20,
  resume21,
  resume22,
  resume23,
];

const SOLVED_TILES = [
  ...TILE_IMAGES.map((src, index) => ({
    id: `tile-${index + 1}`,
    src,
    label: `Tile ${index + 1}`,
  })),
  { id: EMPTY_TILE_ID, label: "Empty slot" },
];

const SOLVED_TILE_IDS = SOLVED_TILES.map((tile) => tile.id);
const DIRECTIONS = {
  up: [-1, 0],
  down: [1, 0],
  left: [0, -1],
  right: [0, 1],
};
const KEY_TO_DIRECTION = {
  ArrowUp: "down",
  w: "down",
  W: "down",
  ArrowDown: "up",
  s: "up",
  S: "up",
  ArrowLeft: "right",
  a: "right",
  A: "right",
  ArrowRight: "left",
  d: "left",
  D: "left",
};
const CONTROL_TO_DIRECTION = {
  up: "down",
  down: "up",
  left: "right",
  right: "left",
};
const SHUFFLE_STEPS = 180;
const SWIPE_THRESHOLD = 28;

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <LandingPage/>
    ),
  },
  {
    path: "/mapdle",
    element: (
      <MapdlePage/>
    ),
  },
  {
    path: "/mapdle-debug",
    element: (
      <MapdleDebugPage/>
    ),
  },
  {
    path: "/resume",
    element: (
      <MainBody/>
    ),
  },
  {
    path: "/tiles",
    element: (
      <MainBody/>
    ),
  },
  {
    path: "/smoking",
    element: (
      <SmokingPage/>
    ),
  },
  {
    path: "/smoking-debug",
    element: (
      <SmokingDebugPage/>
    ),
  },
  {
    path: "/baccarat",
    element: (
      <BaccaratPage/>
    ),
  },
  {
    path: "/perfect-pitch",
    element: (
      <PerfectPitchPage/>
    ),
  },
  {
    path: "/maptap",
    element: (
      <MaptapPage/>
    ),
  },
  {
    path: "/iran-war",
    element: (
      <IranWarPage/>
    ),
  },
  {
    path: "/ultimate-texas-holdem",
    element: (
      <UltimateTexasHoldemPage/>
    ),
  },
  {
    path: "/ultimate-texas-holdem/chart",
    element: (
      <UltimateTexasHoldemChartPage/>
    ),
  },
  {
    path: "/hanzi-blitz",
    element: <HanziBlitzPage />,
  },
  {
    path: "/hanzi-blitz/privacy",
    element: <HanziRecallPrivacyPage />,
  },
  {
    path: "/hanzi-recall/privacy",
    element: (
      <HanziRecallPrivacyPage/>
    ),
  }
]);

function App() {
  return <RouterProvider router={router} />;
}

function LandingPage() {
  return (
    <main className="landingPage">
      <img
        className="landingPhoto"
        src={landingPortrait}
        alt="Baby looking off camera"
      />
      <div className="landingShade" aria-hidden="true" />
      <section className="landingContent" aria-label="Home">
        <h1>Big ideas, tiny man</h1>
        <nav className="landingLinks" aria-label="Primary pages">
          <Link to="/resume">Resume</Link>
          <Link to="/hanzi-blitz">Hanzi Blitz</Link>
          <Link to="/mapdle">Mapdle</Link>
          <Link to="/smoking">Smoking</Link>
          <Link to="/baccarat">Baccarat</Link>
          <Link to="/perfect-pitch">Pitch Color</Link>
          <Link to="/maptap">MapTap Endless</Link>
          <Link to="/iran-war">Iran War Status</Link>
          <Link to="/ultimate-texas-holdem">UTH Trainer</Link>
        </nav>
      </section>
    </main>
  );
}

function indexToPosition(index) {
  return {
    row: Math.floor(index / COLUMN_COUNT),
    column: index % COLUMN_COUNT,
  };
}

function positionToIndex({ row, column }) {
  return row * COLUMN_COUNT + column;
}

function isInsideBoard({ row, column }) {
  return row >= 0 && row < ROW_COUNT && column >= 0 && column < COLUMN_COUNT;
}

function findEmptyPosition(tiles) {
  return indexToPosition(tiles.findIndex((tile) => tile.id === EMPTY_TILE_ID));
}

function swapTiles(tiles, firstIndex, secondIndex) {
  const nextTiles = [...tiles];
  [nextTiles[firstIndex], nextTiles[secondIndex]] = [
    nextTiles[secondIndex],
    nextTiles[firstIndex],
  ];
  return nextTiles;
}

function moveEmptyTile(tiles, direction) {
  const emptyPosition = findEmptyPosition(tiles);
  const [rowOffset, columnOffset] = DIRECTIONS[direction];
  const targetPosition = {
    row: emptyPosition.row + rowOffset,
    column: emptyPosition.column + columnOffset,
  };

  if (!isInsideBoard(targetPosition)) {
    return tiles;
  }

  return swapTiles(
    tiles,
    positionToIndex(emptyPosition),
    positionToIndex(targetPosition)
  );
}

function moveClickedTile(tiles, tileId) {
  const tileIndex = tiles.findIndex((tile) => tile.id === tileId);
  const tilePosition = indexToPosition(tileIndex);
  const emptyPosition = findEmptyPosition(tiles);
  const rowDistance = Math.abs(tilePosition.row - emptyPosition.row);
  const columnDistance = Math.abs(tilePosition.column - emptyPosition.column);

  if (rowDistance + columnDistance !== 1) {
    return tiles;
  }

  return swapTiles(tiles, tileIndex, positionToIndex(emptyPosition));
}

function canMove(tiles, direction) {
  const emptyPosition = findEmptyPosition(tiles);
  const [rowOffset, columnOffset] = DIRECTIONS[direction];
  return isInsideBoard({
    row: emptyPosition.row + rowOffset,
    column: emptyPosition.column + columnOffset,
  });
}

function getSwipeDirection(start, end) {
  const deltaX = end.x - start.x;
  const deltaY = end.y - start.y;

  if (Math.max(Math.abs(deltaX), Math.abs(deltaY)) < SWIPE_THRESHOLD) {
    return null;
  }

  if (Math.abs(deltaX) > Math.abs(deltaY)) {
    return deltaX > 0 ? "right" : "left";
  }

  return deltaY > 0 ? "down" : "up";
}

function getTileMoveDirection(tiles, tileId) {
  const tileIndex = tiles.findIndex((tile) => tile.id === tileId);

  if (tileIndex < 0) {
    return null;
  }

  const tilePosition = indexToPosition(tileIndex);
  const emptyPosition = findEmptyPosition(tiles);
  const rowDistance = emptyPosition.row - tilePosition.row;
  const columnDistance = emptyPosition.column - tilePosition.column;

  if (Math.abs(rowDistance) + Math.abs(columnDistance) !== 1) {
    return null;
  }

  if (rowDistance < 0) {
    return "up";
  }

  if (rowDistance > 0) {
    return "down";
  }

  return columnDistance < 0 ? "left" : "right";
}

function isSolved(tiles) {
  return tiles.every((tile, index) => tile.id === SOLVED_TILE_IDS[index]);
}

function shuffleTiles() {
  let tiles = [...SOLVED_TILES];
  let previousEmptyIndex = null;

  for (let step = 0; step < SHUFFLE_STEPS; step += 1) {
    const emptyPosition = findEmptyPosition(tiles);
    const options = [];

    for (const [rowOffset, columnOffset] of Object.values(DIRECTIONS)) {
      const position = {
        row: emptyPosition.row + rowOffset,
        column: emptyPosition.column + columnOffset,
      };

      if (
        isInsideBoard(position) &&
        positionToIndex(position) !== previousEmptyIndex
      ) {
        options.push(position);
      }
    }

    const targetPosition = options[Math.floor(Math.random() * options.length)];
    previousEmptyIndex = positionToIndex(emptyPosition);
    tiles = swapTiles(
      tiles,
      positionToIndex(emptyPosition),
      positionToIndex(targetPosition)
    );
  }

  return isSolved(tiles) ? moveEmptyTile(tiles, "left") : tiles;
}

function createGameState(tiles = shuffleTiles(), moves = 0) {
  return {
    tiles,
    moves,
    isComplete: isSolved(tiles),
  };
}

function gameReducer(state, action) {
  if (action.type === "shuffle") {
    return createGameState();
  }

  if (state.isComplete) {
    return state;
  }

  const nextTiles =
    action.type === "move"
      ? moveEmptyTile(state.tiles, action.direction)
      : moveClickedTile(state.tiles, action.tileId);

  if (nextTiles === state.tiles) {
    return state;
  }

  return createGameState(nextTiles, state.moves + 1);
}

function MainBody() {
  const [{ tiles, isComplete }, dispatch] = useReducer(
    gameReducer,
    undefined,
    () => createGameState()
  );
  const swipeStartRef = useRef(null);
  const suppressClickRef = useRef(false);
  const availableMoves = Object.fromEntries(
    Object.keys(DIRECTIONS).map((direction) => [
      direction,
      canMove(tiles, direction),
    ])
  );
  const emptyPosition = findEmptyPosition(tiles);

  useEffect(() => {
    function handleKeyDown(event) {
      const direction = KEY_TO_DIRECTION[event.key];

      if (!direction) {
        return;
      }

      event.preventDefault();
      dispatch({ type: "move", direction });
    }

    window.addEventListener("keydown", handleKeyDown);

    return function cleanup() {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  function handleSwipeStart(event) {
    if (!event.isPrimary || isComplete) {
      return;
    }

    const tileElement = event.target.closest("[data-tile-id]");

    if (!tileElement || !event.currentTarget.contains(tileElement)) {
      return;
    }

    swipeStartRef.current = {
      pointerId: event.pointerId,
      tileId: tileElement.dataset.tileId,
      x: event.clientX,
      y: event.clientY,
    };
    event.currentTarget.setPointerCapture(event.pointerId);
  }

  function handleSwipeEnd(event) {
    const swipeStart = swipeStartRef.current;

    if (!swipeStart || swipeStart.pointerId !== event.pointerId) {
      return;
    }

    swipeStartRef.current = null;

    const swipeDirection = getSwipeDirection(swipeStart, {
      x: event.clientX,
      y: event.clientY,
    });
    const tileMoveDirection = getTileMoveDirection(tiles, swipeStart.tileId);

    if (swipeDirection && swipeDirection === tileMoveDirection) {
      suppressClickRef.current = true;
      event.preventDefault();
      dispatch({ type: "move-tile", tileId: swipeStart.tileId });
    }
  }

  function handleSwipeCancel() {
    swipeStartRef.current = null;
  }

  return (
    <main className="tileGamePage">
      <section className="tileGameShell" aria-label="Tile game">
        <div className="tileGameLayout">
          <div
            className={`tileBoard ${isComplete ? "tileBoardComplete" : ""}`}
            role="grid"
            aria-label="Sliding tile board"
            onPointerDown={handleSwipeStart}
            onPointerUp={handleSwipeEnd}
            onPointerCancel={handleSwipeCancel}
          >
            {tiles.map((tile, index) => {
              const position = indexToPosition(index);
              const isEmpty = tile.id === EMPTY_TILE_ID;
              const isMovable =
                !isEmpty &&
                Math.abs(position.row - emptyPosition.row) +
                  Math.abs(position.column - emptyPosition.column) ===
                  1;

              return (
                <button
                  key={tile.id}
                  data-tile-id={tile.id}
                  className={`tileButton ${
                    isEmpty ? "tileButtonEmpty" : ""
                  } ${isMovable ? "tileButtonMovable" : ""}`}
                  style={{
                    "--tile-row": position.row,
                    "--tile-column": position.column,
                  }}
                  type="button"
                  role="gridcell"
                  aria-label={tile.label}
                  aria-disabled={isEmpty || isComplete || !isMovable}
                  tabIndex={isMovable && !isComplete ? 0 : -1}
                  onClick={(event) => {
                    if (suppressClickRef.current) {
                      suppressClickRef.current = false;
                      event.preventDefault();
                      return;
                    }

                    if (!isMovable || isComplete) {
                      event.preventDefault();
                      return;
                    }

                    dispatch({ type: "move-tile", tileId: tile.id });
                  }}
                >
                  {!isEmpty && (
                    <img src={tile.src} alt="" draggable="false" />
                  )}
                </button>
              );
            })}
          </div>

          <div className="tileControls" aria-label="Game controls">
            <div className="directionPad">
              <button
                className="directionButton directionButtonUp"
                type="button"
                title="Move up"
                aria-label="Move up"
                disabled={!availableMoves[CONTROL_TO_DIRECTION.up] || isComplete}
                onClick={() =>
                  dispatch({ type: "move", direction: CONTROL_TO_DIRECTION.up })
                }
              >
                <span className="arrowIcon arrowIconUp" aria-hidden="true" />
              </button>
              <button
                className="directionButton directionButtonLeft"
                type="button"
                title="Move left"
                aria-label="Move left"
                disabled={!availableMoves[CONTROL_TO_DIRECTION.left] || isComplete}
                onClick={() =>
                  dispatch({ type: "move", direction: CONTROL_TO_DIRECTION.left })
                }
              >
                <span className="arrowIcon arrowIconLeft" aria-hidden="true" />
              </button>
              <button
                className="directionButton directionButtonRight"
                type="button"
                title="Move right"
                aria-label="Move right"
                disabled={!availableMoves[CONTROL_TO_DIRECTION.right] || isComplete}
                onClick={() =>
                  dispatch({
                    type: "move",
                    direction: CONTROL_TO_DIRECTION.right,
                  })
                }
              >
                <span className="arrowIcon arrowIconRight" aria-hidden="true" />
              </button>
              <button
                className="directionButton directionButtonDown"
                type="button"
                title="Move down"
                aria-label="Move down"
                disabled={!availableMoves[CONTROL_TO_DIRECTION.down] || isComplete}
                onClick={() =>
                  dispatch({
                    type: "move",
                    direction: CONTROL_TO_DIRECTION.down,
                  })
                }
              >
                <span className="arrowIcon arrowIconDown" aria-hidden="true" />
              </button>
            </div>

            <div className="actionButtons">
              <button type="button" onClick={() => dispatch({ type: "shuffle" })}>
                Shuffle
              </button>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}


export default App;
